import styled from 'styled-components';
import Icon from 'components/Icon';
import Colors from '../../constants/Colors';
import { Text, FontWeight } from '../Text';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  min-height: 100vh;
  width: 340px;

.open{
    transition: all 1.5s;
  }
`;

const Content = styled.div`
  width: 340px;
  min-height: 200px;
`;

const Settings = styled.div`
  min-height: 200px;
  span{
    line-height: 30px;
    font-weight: ${FontWeight.Bold};
    padding-left: 35px;
    i{
      margin-top: 0px;
    }
  }

  /* margin-left: 20px;
  span{
    line-height: normal;
    font-weight: ${FontWeight.Bold};
    font-size: 15px;
  }

  i{
    margin-top: 0px;
  } */

/*   .icon-user:before{
    background-size: 25px 20px;
    width: 25px;
    height: 20px;
  }

  .icon-logout:before{
    background-size: 24px 24px;
    width: 24px;
    height: 24px;
  } */
`;

const Topo = styled.div`
  width: 340px;
  margin-top: 30px;
  margin-bottom:40px;
  background: #fff;
  height: 110px;
`;

const Photo = styled.div`
  width: 70px;
  height: 70px;
  background: #fff;
  box-shadow: 0px 8px 20px 3px rgba(171, 171, 171, 0.22);
  border-radius: 50px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 14px;
  padding-top: 10px;

  .icon-user-gray:before{
    background-size: contain;
    width: 45px;
    height: 38px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 5px;
  }

  .icon-check-ok-green{
    margin-left: 45px;
    ::before{
      background-size: 24px 24px;
      display: inline-block;
      width: 24px;
      height: 24px;
    }
  }
`;

const Name = styled(Text)`
  text-align: center;
  width: 100%;
  display: block;
  margin-top: 10px;
  font-weight: ${FontWeight.Black};
  color: ${Colors.GRAY[2]};
  font-size: 16px;
`;

const Title = styled(Text)`
  font-size: 14px;
  padding-left: 35px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: ${FontWeight.Bold};
  color: ${Colors.GRAY[7]};
  margin-top: 40px;
  display: block;
`;

const List = styled.ul`
  width: 100%;
  min-height: 100px;
  list-style-type: none;
  padding-inline-start: 0px;
  margin-top: 5px;
  a{
    text-decoration: none;
  }
`;

const Item = styled(Text)`
  color: ${Colors.GRAY[3]};
  padding-left: 15px;
  padding-top: 15px;
  margin: 10px 20px 0px 20px;
  display: block;
  
  p{
    margin: 0px;
    font-weight: ${FontWeight.Medium};
    font-size: 15px;
    line-height: auto;
  }

  span{
    font-weight: ${FontWeight.Bold};
    font-size: 14px;
    padding-top: 5px;
    text-transform: uppercase;
    line-height: 17px;
    display: inline-block;
  }

  i{
    margin-right: 20px;
    float: left;
    margin-top: 5px;
  }

`;

const Remember = styled.div`
  margin-left: 20px;
  p{
    font-size: 14px;
    display: block;
  }

  span{
    font-size: 14px;
    display: block;
  }
`;

const SubTitle = styled(Text)`
  font-size: 16px;
  color: ${Colors.SECONDARY};
  font-weight: ${FontWeight.Bold};
  opacity: 0.6;
  letter-spacing: 2px;
`;

const ElipseIcon = styled(Icon)`
border-radius: 100%;
height: 40px;
width: 40px;
padding: 7px;
background:${Colors.SECONDARY};
`;

export { Topo, Photo, Name, Title, List, Item, Remember, Settings, SubTitle, Container, Content, ElipseIcon };
